import { render, staticRenderFns } from "./AppPeace.vue?vue&type=template&id=401f1466&"
import script from "./AppPeace.vue?vue&type=script&lang=js&"
export * from "./AppPeace.vue?vue&type=script&lang=js&"
import style0 from "./AppPeace.vue?vue&type=style&index=0&id=401f1466&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports